/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_Support_DescriptionInputs */

const en_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get help using the Brave browser or Brave Search, adjusting privacy settings, opening a private window, or find general info about Brave.`)
};

const id_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan bantuan terkait penggunaan browser Brave atau Brave Penelusuran, menyesuaikan pengaturan privasi, membuka jendela pribadi, atau menemukan info umum tentang Brave.`)
};

const ms_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan bantuan menggunakan penyemak imbas Brave atau Carian Brave, menyesuaikan tetapan privasi, membuka tetingkap privet, atau mencari maklumat umum tentang Brave.`)
};

const ca_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtingues ajuda per utilitzar el navegador o Cercador de Brave, configurar els ajustos de privacitat, obrir una finestra privada o trobar informació general sobre Brave.`)
};

const cs_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte pomoc s používáním prohlížeče nebo vyhledávače Brave, úpravou nastavení ochrany soukromí, otevřením soukromého okna nebo vyhledáním obecných informací o Brave.`)
};

const da_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hjælp til at bruge Brave-browseren eller Brave Søgning, justere privatlivsindstillinger, åbne et privat vindue eller finde generel information om Brave.`)
};

const de_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier erhältst du Hilfe zur Nutzung des Brave-Browsers oder der Brave- Suchfunktion, zum Anpassen der Datenschutzeinstellungen, zum Öffnen eines privaten Fensters oder zu allgemeinen Informationen über Brave.`)
};

const et_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saage abi Brave'i brauseri või Brave'i otsingu kasutamisel, privaatsusseadete kohandamisel, privaatse akna avamisel või leidke üldist teavet Brave'i kohta.`)
};

const es_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén ayuda para usar el navegador de Brave o Brave Search, cambiar tus ajustes de privacidad, abrir una ventana privada o encontrar información general sobre Brave.`)
};

const fr_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez de l’aide concernant le navigateur Brave ou le moteur de recherche Brave, les paramètres de confidentialité, les fenêtres de navigation privée ou Brave de manière générale.`)
};

const hr_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobijte pomoć u korištenju preglednika Brave ili tražilice Brave, prilagodbi postavki privatnosti, otvaranju privatnog prozora ili pronađite općenite informacije o Braveu.`)
};

const it_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi aiuto riguardo il browser Brave, Ricerca Brave, le impostazioni della privacy, le finestre private o informazioni generali.`)
};

const lv_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemiet palīdzību par Brave pārlūka vai Brave meklēšanas lietošanu, privātuma iestatījumu pielāgošanu, privāta loga atvēršanu vai iegūstiet vispārīgu informāciju par Brave.`)
};

const lt_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite pagalbos naudodami „Brave“ naršyklę arba „Brave“ paiešką, koreguodami privatumo nustatymus, atidarydami privatų langą arba gaudami bendros informacijos apie „Brave“.`)
};

const hu_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segítséget kaphat a Brave böngésző vagy a Brave keresés használatához, az adatvédelmi beállítások módosításához, egy privát ablak megnyitásához, vagy általános információkat találhat a Brave-ról.`)
};

const nl_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg hulp bij het gebruik van de Brave-browser of Brave Search, het aanpassen van privacy-instellingen, het openen van een privévenster of lees algemene informatie over Brave.`)
};

const nb_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hjelp med å bruke nettleseren og søkemotoren fra Brave, justere personverninnstillingene, åpne private vinduer og finn mer informasjon om Brave.`)
};

const pl_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj pomoc w korzystaniu z przeglądarki Brave lub wyszukiwarki Brave Search, dostosowaniu ustawień prywatności, otwieraniu okna prywatnego lub zobacz ogólne informacje o Brave.`)
};

const pt_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha ajuda usando o navegador Brave ou a Pesquisa Brave, ajustando configurações de privacidade, abrindo janelas privadas ou encontre informações gerais sobre o Brave.`)
};

const ro_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține ajutor folosind browser-ul Brave sau Brave Search, ajustând setările de confidențialitate, deschizând o fereastră privată sau găsește informații generale despre Brave.`)
};

const sk_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získajte pomoc pri používaní prehliadača Brave alebo Vyhľadávania Brave, úprave nastavení ochrany súkromia, otvorení súkromného okna alebo nájdite všeobecné informácie o Brave.`)
};

const sl_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poiščite pomoč pri uporabi brskalnika Brave ali Brave Iskanja, prilagodite nastavitve zasebnosti, odprite zasebno okno ali poiščite splošne informacije o brskalniku Brave.`)
};

const fi_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki apua Brave-selaimen tai Brave Searchin käytössä, yksityisyysasetusten säätämisessä, yksityisen ikkunan avaamisessa tai löydä yleistä tietoa Bravesta.`)
};

const sv_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hjälp med att använda Brave-webbläsaren eller Brave Sök, justera sekretessinställningar, öppna ett privat fönster eller hitta allmän information om Brave.`)
};

const vi_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận hỗ trợ khi sử dụng trình duyệt Brave hoặc Brave Tìm kiếm, điều chỉnh cài đặt quyền riêng tư, mở cửa sổ riêng tư hoặc tìm thông tin chung về Brave.`)
};

const tr_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave tarayıcısını veya Brave Arama'yı kullanma, gizlilik ayarlarını yapma, bir gizli pencere açma konusunda yardım alın veya Brave hakkında genel bilgilere ulaşın.`)
};

const el_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λάβετε βοήθεια για τη χρήση του προγράμματος περιήγησης Brave ή του Brave Search, την προσαρμογή των ρυθμίσεων απορρήτου, το άνοιγμα ενός ιδιωτικού παραθύρου ή βρείτε γενικές πληροφορίες σχετικά με το Brave.`)
};

const bg_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получи помощ за използването на браузъра Brave или Brave Търсене, за промяна на настройките за поверителност, за отваряне на поверителен прозорец, или намери обща информация за Brave.`)
};

const ru_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите помощь в использовании браузера Brave или Brave Search, настройке параметров конфиденциальности, открытии приватного окна или найдите общую информацию о Brave.`)
};

const sr_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потражите помоћ око коришћења Brave прегледача или Brave претраге, подешавањима приватности, отварању приватног прозора или пронађите опште информације о Brave-у.`)
};

const uk_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дізнайтесь, як користуватися браузером Brave або Пошуком Brave, як налаштувати параметри приватності, відкрити приватне вікно або знайти загальну довідкову інформацію про Brave.`)
};

const ka_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ დახმარება Brave ბრაუზერის ან Brave ძებნის გამოყენებით, კონფიდენციალურობის პარამეტრების რეგულირებაში, პირადი ფანჯრის გახსნაში ან Brave-ის შესახებ ზოგადი ინფორმაციის მოძიებაში.`)
};

const hi_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव ब्राउज़र या ब्रेव सर्च का उपयोग करने, प्राइवेसी सेटिंग एडजस्ट करने, प्राइवेट विंडो खोलने या ब्रेव के बारे में जनरल जानकारी प्राप्त करने में सहायता प्राप्त करें।`)
};

const th_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอความช่วยเหลือในการใช้เบราว์เซอร์ Brave หรือ Brave Search การปรับการตั้งค่าความเป็นส่วนตัว การเปิดหน้าต่างส่วนตัว หรือค้นหาข้อมูลทั่วไปเกี่ยวกับ Brave`)
};

const ko_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 브라우저 또는 Brave 검색을 사용하거나, 개인정보 보호 설정을 조정하거나, 비공개 창을 열거나, Brave에 대한 일반 정보를 찾는 데 도움을 받아보세요.`)
};

const zh_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取有关使用 Brave 浏览器或 Brave 搜索的帮助，调整隐私设置，打开无痕窗口，或查找有关 Brave 的一般信息。`)
};

const zh_tw_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲取使用 Brave 瀏覽器或 Brave 搜尋的協助、調整隱私設定、開啟無痕視窗，或查找有關 Brave 的基本資訊。`)
};

const ja_other_support_description = /** @type {(inputs: Other_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BraveブラウザやBrave Searchの使い方、プライバシー設定の調整、プライベートウィンドウの開き方など、さまざまなヘルプやBraveに関する一般的な情報をご覧ください。`)
};

/**
* | output |
* | --- |
* | "Get help using the Brave browser or Brave Search, adjusting privacy settings, opening a private window, or find general info about Brave." |
*
* @param {Other_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const other_support_description = /** @type {((inputs?: Other_Support_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_Support_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_other_support_description(inputs)
	if (locale === "ms") return ms_other_support_description(inputs)
	if (locale === "ca") return ca_other_support_description(inputs)
	if (locale === "cs") return cs_other_support_description(inputs)
	if (locale === "da") return da_other_support_description(inputs)
	if (locale === "de") return de_other_support_description(inputs)
	if (locale === "et") return et_other_support_description(inputs)
	if (locale === "es") return es_other_support_description(inputs)
	if (locale === "fr") return fr_other_support_description(inputs)
	if (locale === "hr") return hr_other_support_description(inputs)
	if (locale === "it") return it_other_support_description(inputs)
	if (locale === "lv") return lv_other_support_description(inputs)
	if (locale === "lt") return lt_other_support_description(inputs)
	if (locale === "hu") return hu_other_support_description(inputs)
	if (locale === "nl") return nl_other_support_description(inputs)
	if (locale === "nb") return nb_other_support_description(inputs)
	if (locale === "pl") return pl_other_support_description(inputs)
	if (locale === "pt") return pt_other_support_description(inputs)
	if (locale === "ro") return ro_other_support_description(inputs)
	if (locale === "sk") return sk_other_support_description(inputs)
	if (locale === "sl") return sl_other_support_description(inputs)
	if (locale === "fi") return fi_other_support_description(inputs)
	if (locale === "sv") return sv_other_support_description(inputs)
	if (locale === "vi") return vi_other_support_description(inputs)
	if (locale === "tr") return tr_other_support_description(inputs)
	if (locale === "el") return el_other_support_description(inputs)
	if (locale === "bg") return bg_other_support_description(inputs)
	if (locale === "ru") return ru_other_support_description(inputs)
	if (locale === "sr") return sr_other_support_description(inputs)
	if (locale === "uk") return uk_other_support_description(inputs)
	if (locale === "ka") return ka_other_support_description(inputs)
	if (locale === "hi") return hi_other_support_description(inputs)
	if (locale === "th") return th_other_support_description(inputs)
	if (locale === "ko") return ko_other_support_description(inputs)
	if (locale === "zh") return zh_other_support_description(inputs)
	if (locale === "zh-tw") return zh_tw_other_support_description(inputs)
	if (locale === "ja") return ja_other_support_description(inputs)
	return en_other_support_description(inputs)
});